/* THIS IS TO CAPITALIZE THE FIRST LETTER OF EACH WORD AND ALSO TRIM THE LEADING SPACE AND ALLOW SPACES IN BETWEEN IN THE INPUT FIELD */

import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appCapitalizeFirst]',
  standalone: false
})
export class CapitalizeFirstDirective {
  private hasCapitalized = false;

  private el = inject(ElementRef<HTMLInputElement>);

  @HostListener('blur')
  onBlur(): void {
    if (!this.el.nativeElement.value?.trim()) {
      this.hasCapitalized = false;
    }
  }

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;

    // 🚫 Remove leading spaces
    let value = input.value.replace(/^\s+/, '');

    if (!value) {
      input.value = '';
      this.hasCapitalized = false;
      return;
    }

    // 🔠 Capitalize first character once
    if (!this.hasCapitalized) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
      this.hasCapitalized = true;
    }

    input.value = value;
  }
}
